import { DeleteOutlined }                  from '@ant-design/icons';
import { QuestionCircleOutlined }          from '@ant-design/icons';
import { Button }                          from 'antd';
import { Modal }                           from 'antd';
import { withNavigation }                  from 'components/App/withNavigation';
import { WithNavigationProps }             from 'components/App/withNavigation';
import dayjs                               from 'dayjs';
import React                               from 'react';
import { Link }                            from 'react-router-dom';
import { observer }                        from 'mobx-react';
import { computed }                        from 'mobx';
import { Slider }                          from 'antd';
import { useState }                        from 'react';
import { useEffect }                       from 'react';
import { PagedCollection }                 from 'collections/PagedCollection';
import { demandListStore }                 from 'stores/index';
import { privateLayoutStore }              from 'stores/index';
import { messageSuccessIntl }              from 'utils/messageIntl';
import { messageErrorIntl }                from 'utils/messageIntl';
import { formatMessageIntl }               from 'utils/messageIntl';
import Rights                              from 'utils/rights';
import currentSession                      from 'utils/currentSession';
import rights                              from 'utils/rights';
import { ApiCollection }                   from 'collections/ApiCollection';
import FormattedMessageWrapper             from 'components/App/FormattedMessageWrapper';
import DemandModel                         from 'models/DemandModel';
import DemandStatusModel                   from 'models/DemandStatusModel';
import DemandTypeModel                     from 'models/DemandTypeModel';
import ListComponent                       from 'components/App/ListComponent';
import DemandStatus                        from '../components/DemandStatus';
import { IN_PROGRESS, REFUSED, VALIDATED } from 'constants/DemandStatuses';
import {
  EXEMPTIONS,
  EXEMPTION_DELIVERY,
  EXEMPTION_DISMANTLING,
  EXEMPTION_MOUNTING,
  LOGISTICS,
  LOGISTIC_MATERIAL,
  LOGISTIC_VEHICLE,
}                                          from 'constants/DemandTypes';
import DropDownMenu                        from 'components/App/DropDownMenu';
import { CsvCollection }                   from 'collections/CsvCollection';
import { downloadFileFromBlob }            from 'utils/downloadFile';
import DemandsCsvModel                     from 'models/DemandsCsvModel';
import Search                              from 'components/App/IntlSearch';
import DemandType                          from '../components/DemandType';
import { pushIfNotExistsAndNotNull }       from 'utils/tools';
import Space                               from 'components/App/Space';
import DemandLogisticsCsvModel             from 'models/DemandLogisticsCsvModel';
import StandModel                          from 'models/StandModel';

interface FiltersReferences {
  treated: {
    treated: boolean,
  },
  unSeen: {
    unSeen: boolean,
  },
  'exemption.in_progress': {
    'demandStatus.reference': string,
    'demandType.reference': string[],
  },
  'exemption.validated': {
    'demandStatus.reference': string,
    'demandType.reference': string[],
  },
  'exemption.refused': {
    'demandStatus.reference': string,
    'demandType.reference': string[],
  },
  'logistic.in_progress': {
    'demandStatus.reference': string,
    'demandType.reference': string[],
  },
  'logistic.validated': {
    'demandStatus.reference': string,
    'demandType.reference': string[],
  },
  'logistic.refused': {
    'demandStatus.reference': string,
    'demandType.reference': string[],
  },
}

interface DemandListTopRightMenuProps {
  demandCollection: PagedCollection;
  exportDemandLogisticsInCsv: () => void;
  exportDemandsInCsv: () => void;
  handleOnSearch: (value: any) => void;
  handleSliderChange: (values: number[]) => void;
}

const DemandListTopRightMenu = ({
  demandCollection,
  exportDemandLogisticsInCsv,
  exportDemandsInCsv,
  handleOnSearch,
  handleSliderChange,
}: DemandListTopRightMenuProps) => {
  const [search, setSearch] = useState('');
  const [sliderValue, setSliderValue] = useState<number[]>([0, 1000]);

  useEffect(() => {
    setSearch(demandCollection.filters.search);

    const lower = demandCollection.filters['stand.surface[gte]'] || 0;
    const higher = demandCollection.filters['stand.surface[lte]'] || 1000;

    setSliderValue([lower, higher]);
  }, []);

  if (!rights.for.demand.export) {
    return null;
  }

  return (
    <Space direction="horizontal" size={16}>
      <div
        style={{
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'space-between',
          width: 200,
        }}
      >
        <div style={{ flex: 1 }}>
          <FormattedMessageWrapper id="Surface" />
        </div>

        <Slider
          defaultValue={[0, 1000]}
          max={1000}
          min={0}
          onChangeComplete={(values: number[]) => {
            handleSliderChange(values);
          }}
          // onAfterChange={(values: [number, number]) => {
          // }}
          onChange={v => setSliderValue(v)}
          range
          style={{ flex: 2, width: '100%' }}
          value={sliderValue}
        />
      </div>

      <Search
        onChange={(event: any) => setSearch(event.target.value)}
        onSearch={handleOnSearch}
        placeholder="Rechercher une demande"
        style={{ width: 200 }}
        value={search}
      />

      <DropDownMenu
        items={[
          {
            icon: null,
            key: 'EXPORT_EXEMPTION_DEMANDS',
            label: <FormattedMessageWrapper id="Exporter demandes dérogation" />,
            onClick: () => exportDemandsInCsv(),
          },
          {
            icon: null,
            key: 'EXPORT_LOGISTIC_DEMANDS',
            label: <FormattedMessageWrapper id="Exporter demandes logistique" />,
            onClick: () => exportDemandLogisticsInCsv(),
          },
        ]}
      />
    </Space>
  );
};

const StandCell = observer(({ demand, property, standCollection }: { demand: DemandModel, property: string, standCollection: ApiCollection<StandModel> }) => {
  const stand = standCollection.find(s => s.id === demand.get('stand.id'));
  if (!stand) {
    return null;
  }
  return <div>{stand.get(property)}</div>;
});

const ActionsCell = observer(({ demand, demandStatusCollection, onSuccess }: { demand: DemandModel, demandStatusCollection: ApiCollection<DemandStatusModel>, onSuccess: () => void }) => {
  if (!Rights.for.demand.delete) {
    return null;
  }

  const demandStatus = demandStatusCollection.findBy('id', demand.demandStatusId);

  if (demandStatus?.reference !== IN_PROGRESS) {
    return null;
  }

  return (
    <Button
      icon={<DeleteOutlined />}
      onClick={event => {
        event.stopPropagation();

        Modal.confirm({
          cancelText: formatMessageIntl("Annuler"),
          content: (
            <p>
              {formatMessageIntl("Cette opération est irréversible.")}
            </p>
          ),
          icon: <QuestionCircleOutlined style={{ color: '#e74c3c' }} />,
          okText: formatMessageIntl("Oui, confirmer la suppression"),
          onOk: async () => {
            try {
              await demand.destroy();
              messageSuccessIntl("Demande supprimée !");
              onSuccess();
            } catch {
              messageErrorIntl("Une erreur s'est produite.");
            }
          },
          title: formatMessageIntl("Confirmez-vous la suppression de cette demande ?"),
        });
      }}
    />
  );
});

@observer
class DemandList extends React.Component<WithNavigationProps> {
  public state = {
    selectedRowKeys: [],
  };

  public async componentDidMount() {
    const { showId } = this.props.params;

    currentSession.showId = showId;

    try {
      await privateLayoutStore.setCurrentShowId(showId);
    } catch (error: any) {
      if (error.name === 'show_not_found') {
        this.props.navigate('/404');
      }

      if (error.name === 'get_show_unauthorized') {
        this.props.navigate('/erreur');
      }

      return;
    }

    await demandListStore.initFromLocalStorage();
  }

  public render() {
    const isLoading =
      !demandListStore.demandCollection.isLoaded ||
      demandListStore.demandCollection.isLoading ||
      demandListStore.demandCollectionFull.isLoading ||
      demandListStore.demandStats.isLoading;

    return (
      <ListComponent
        collection={demandListStore.demandCollection}
        columns={this.columns}
        columnsFilters={this.columnsFilters}
        defaultSorter={{
          createdAt: 'desc',
        }}
        fetchData={this.fetchData}
        filters={this.filters}
        filtersReferences={this.filtersReferences}
        loading={isLoading}
        onFilterChange={filterName => {
          const newFilters = this.addAdditionalFilters(demandListStore.demandCollection.filters, filterName);

          this.fetchData(1, newFilters, demandListStore.demandCollection.sorts);
        }}
        onRowClick={modelId => {
          this.props.navigate(`/demandes/${modelId}`);
        }}
        rawFilters={demandListStore.rawFilters}
        setSelectedRowKeys={selectedRowKeys => this.setState({ selectedRowKeys })}
        title={<FormattedMessageWrapper id="Demandes" />}
        topRightWidget={this.renderTopRightWidget()}
      />
    );
  }

  public renderTopRightWidget = () => (
    <DemandListTopRightMenu
      demandCollection={demandListStore.demandCollection}
      exportDemandLogisticsInCsv={this.exportDemandLogisticsInCsv}
      exportDemandsInCsv={this.exportDemandsInCsv}
      handleOnSearch={value => {
        this.fetchData(
          1,
          { ...demandListStore.demandCollection.filters, search: value },
          demandListStore.demandCollection.sorts,
        );
      }}
      handleSliderChange={values => {
        const filters: Record<string, any> = {
          'stand.surface[gte]': undefined,
          'stand.surface[lte]': undefined,
        };

        const [min, max] = values;
        filters['stand.surface[gte]'] = min;

        if (max < 100) {
          filters['stand.surface[lte]'] = max;
        }

        this.fetchData(
          1,
          { ...demandListStore.demandCollection.filters, ...filters },
          demandListStore.demandCollection.sorts,
        );
      }}
    />
  );

  private addAdditionalFilters = (filters: Record<string, any>, filterName: keyof FiltersReferences) => {
    let withAdditionalFilters: Record<string, any> = {
      ...filters,
      'demandStatus.reference': undefined,
      'demandType.reference': undefined,
      treated: undefined,
      unSeen: undefined,
    };

    if (this.filtersReferences[filterName]) {
      withAdditionalFilters = {
        ...withAdditionalFilters,
        ...this.filtersReferences[filterName],
      };
    }

    return withAdditionalFilters;
  };

  private exportDemandLogisticsInCsv = async () => {
    const filters: Record<string, any> = {};

    if (this.state.selectedRowKeys.length > 0) {
      filters['demand.id'] = this.state.selectedRowKeys;
    } else {
      Object.keys(demandListStore.demandCollection.filters).forEach(filterName => {
        filters[`demand.${filterName}`] = demandListStore.demandCollection.filters[filterName];
      });
    }

    if (filters['demand.demandType.reference']) {
      filters['demand.demandType.reference'] = filters['demand.demandType.reference'].filter(
          (ref: string) => !!LOGISTICS.find(r => r === ref),
      );
    } else {
      filters['demand.demandType.reference'] = LOGISTICS;
    }

    const sorts = {};
    Object.keys(demandListStore.demandCollection.sorts).forEach(sortName => {
      filters[`demand.${sortName}`] = demandListStore.demandCollection.sorts[sortName];
    });

    const demandLogisticsCsvCollection = new CsvCollection(DemandLogisticsCsvModel);
    demandLogisticsCsvCollection.setFilters(filters);
    demandLogisticsCsvCollection.setSorts(sorts);

    try {
      const response: any = await demandLogisticsCsvCollection.list();

      const blob = new Blob([response.data], { type: 'text/csv' });
      const time = dayjs().format('YYYY-MM-DD_HHmm');
      const filename = `demandes_logistique_salon_${demandListStore.show.id}_${time}.csv`;
      downloadFileFromBlob(blob, filename);
    } catch {
      messageErrorIntl("Une erreur s'est produite.");
    }
  };

  private exportDemandsInCsv = async () => {
    let filters: any = {};

    if (this.state.selectedRowKeys.length > 0) {
      filters.id = this.state.selectedRowKeys;
    } else {
      filters = { ...demandListStore.demandCollection.filters };
    }

    if (filters['demandType.reference']) {
      filters['demandType.reference'] = filters['demandType.reference'].filter(
          (ref: string) => !!EXEMPTIONS.find(r => r === ref),
      );
    } else {
      filters['demandType.reference'] = EXEMPTIONS;
    }

    const demandsCsvCollection = new CsvCollection(DemandsCsvModel);
    demandsCsvCollection.setFilters(filters);
    demandsCsvCollection.sorts = demandListStore.demandCollection.sorts;

    try {
      const response: any = await demandsCsvCollection.list();

      const blob = new Blob([response.data], { type: 'text/csv' });
      const time = dayjs().format('YYYY-MM-DD_HHmm');
      const filename = `demandes_dérogation_salon_${demandListStore.show.id}_${time}.csv`;
      downloadFileFromBlob(blob, filename);
    } catch {
      messageErrorIntl("Une erreur s'est produite.");
    }
  };

  private fetchData = async (
    pagination: any,
    filters: Record<string, any>,
    sorter: Record<string, 'asc' | 'desc'>,
  ) => {
    const { showId } = this.props.params;

    await demandListStore.setAndSaveRawFilters(filters, sorter);

    try {
      await demandListStore.load(
        showId,
        { current: pagination.current || 1 },
        demandListStore.apiFilters,
        demandListStore.sorts,
      );
    } catch (error: any) {
      const requestStatus = error?.connectorError?.request?.status || error?.connectorError?.response?.status;

      if (requestStatus === 401) {
        this.props.navigate(`/login`);
      } else if (requestStatus === 404 || requestStatus === 405) {
        this.props.navigate(`/404`);
      } else {
        this.props.navigate(`/erreur`);
      }

      return;
    }

    if (currentSession.isStandist) {
      if (demandListStore.demandCollection.length === 1) {
        const demand = demandListStore.demandCollection.first();
        this.props.navigate(`/demandes/${demand?.id}`);
      }
    }

    // currentFilters.saveFiltersAndSorts(
    //   window.location.pathname,
    //   demandListStore.demandCollection.filters,
    //   demandListStore.demandCollection.sorts,
    // );
  };

  @computed
  get filters() {
    const filters: any = {};

    if (currentSession.isAdminOrSupport) {
      filters.messages = {
        filters: {
          unSeen: {
            title: <FormattedMessageWrapper id="Nouveaux" />,
            value: demandListStore.demandStats.totalUnSeen,
          },
          treated: {
            title: <FormattedMessageWrapper id="Non-traités" />,
            value: demandListStore.demandStats.totalUnTreated,
          },
        },
        title: <FormattedMessageWrapper id="Messages" />,
      };
    }

    filters.exemption = {
      filters: {
        'exemption.in_progress': {
          title: <FormattedMessageWrapper id="En cours" />,
          value: demandListStore.demandStats.exemptionInProgress,
        },
        'exemption.validated': {
          title: <FormattedMessageWrapper id="Validés" />,
          value: demandListStore.demandStats.exemptionValidated,
        },
        'exemption.refused': {
          title: <FormattedMessageWrapper id="Refusés" />,
          value: demandListStore.demandStats.exemptionRefused,
        },
      },
      title: <FormattedMessageWrapper id="Dérogations" />,
    };

    filters.logistic = {
      filters: {
        'logistic.in_progress': {
          title: <FormattedMessageWrapper id="En cours" />,
          value: demandListStore.demandStats.logisticInProgress,
        },
        'logistic.validated': {
          title: <FormattedMessageWrapper id="Validés" />,
          value: demandListStore.demandStats.logisticValidated,
        },
        'logistic.refused': {
          title: <FormattedMessageWrapper id="Refusés" />,
          value: demandListStore.demandStats.logisticRefused,
        },
      },
      title: <FormattedMessageWrapper id="Logistique" />,
    };

    return filters;
  }

  get filtersReferences(): FiltersReferences {
    return {
      treated: {
        treated: false,
      },
      unSeen: {
        unSeen: true,
      },
      'exemption.in_progress': {
        'demandStatus.reference': IN_PROGRESS,
        'demandType.reference': [EXEMPTION_DELIVERY, EXEMPTION_MOUNTING, EXEMPTION_DISMANTLING],
      },
      'exemption.validated': {
        'demandStatus.reference': VALIDATED,
        'demandType.reference': [EXEMPTION_DELIVERY, EXEMPTION_MOUNTING, EXEMPTION_DISMANTLING],
      },
      'exemption.refused': {
        'demandStatus.reference': REFUSED,
        'demandType.reference': [EXEMPTION_DELIVERY, EXEMPTION_MOUNTING, EXEMPTION_DISMANTLING],
      },
      'logistic.in_progress': {
        'demandStatus.reference': IN_PROGRESS,
        'demandType.reference': [LOGISTIC_MATERIAL, LOGISTIC_VEHICLE],
      },
      'logistic.validated': {
        'demandStatus.reference': VALIDATED,
        'demandType.reference': [LOGISTIC_MATERIAL, LOGISTIC_VEHICLE],
      },
      'logistic.refused': {
        'demandStatus.reference': REFUSED,
        'demandType.reference': [LOGISTIC_MATERIAL, LOGISTIC_VEHICLE],
      },
    };
  }

  @computed
  get columns() {
    return [
      {
        intlTitle: 'MAJ',
        property: 'updatedAt',
        render: (model: DemandModel) => model.updatedAtDate.format('DD/MM/YYYY HH:mm'),
        sorter: true,
      },
      {
        intlTitle: 'Num',
        property: 'id',
        render: (model: DemandModel) => (
          <Link to={`/demandes/${model.id}`}>
            <b>{model.formattedId}</b>
          </Link>
        ),
        sorter: true,
      },
      {
        intlTitle: 'Enseigne',
        property: 'stand.name',
        render: (model: DemandModel) => (
          <StandCell demand={model} property="name" standCollection={demandListStore.standCollection} />
        ),
      },
      {
        intlTitle: 'Hall',
        property: 'stand.hall',
        render: (model: DemandModel) => (
          <StandCell demand={model} property="hall" standCollection={demandListStore.standCollection} />
        ),
        sorter: true,
      },
      {
        intlTitle: 'Surface',
        property: 'stand.surface',
        render: (model: DemandModel) => (
          <StandCell demand={model} property="surface" standCollection={demandListStore.standCollection} />
        ),
        sorter: true,
      },
      {
        intlTitle: 'Allée',
        property: 'aisle',
        render: (model: DemandModel) => (
          <StandCell demand={model} property="aisle" standCollection={demandListStore.standCollection} />
        ),
        sorter: true,
      },
      {
        intlTitle: 'Type',
        property: 'standType',
        render: (model: DemandModel) => (
          <StandCell demand={model} property="standType" standCollection={demandListStore.standCollection} />
        ),
        sorter: true,
      },
      {
        intlTitle: 'Type de demande',
        property: 'demandType',
        render: (model: DemandModel) => (
          <DemandType demand={model} demandTypeCollection={demandListStore.demandTypeCollection} />
        ),
        sorter: true,
      },
      {
        intlTitle: 'Etat',
        property: 'demandStatus',
        render: (model: DemandModel) => (
          <DemandStatus demand={model} demandStatusCollection={demandListStore.demandStatusCollection} />
        ),
        sorter: true,
      },
      {
        intlTitle: 'Demandeur',
        render: (model: DemandModel) => <div>{model.fullName}</div>,
      },
      {
        render: (model: DemandModel) => (
          <ActionsCell
            demand={model}
            demandStatusCollection={demandListStore.demandStatusCollection}
            onSuccess={() =>
              this.fetchData(1, demandListStore.demandCollection.filters, demandListStore.demandCollection.sorts)
            }
          />
        ),
      },
    ];
  }

  @computed
  get columnsFilters() {
    const columnsFilters = {
      demandStatus: [],
      demandType: [],
      'stand.hall': [],
      'stand.surface': [
        { text: '0 à 10', value: '0_to_10' },
        { text: '11 à 20', value: '11_to_20' },
        { text: '21 à 30', value: '21_to_30' },
        { text: '31 à 40', value: '31_to_40' },
        { text: '41 à 50', value: '41_to_50' },
        { text: '+50', value: '51_to_' },
      ],
    };

    demandListStore.standCollectionFull.forEach((stand: StandModel) => {
      pushIfNotExistsAndNotNull(
        columnsFilters['stand.hall'],
        {
          text: `Stand hall ${stand.hall}`,
          value: stand.hall,
        },
        'value',
      );
    });

    demandListStore.demandTypeCollection.forEach((demandType: DemandTypeModel) => {
      pushIfNotExistsAndNotNull(
        columnsFilters.demandType,
        {
          text: demandType.label,
          value: demandType.iri,
        },
        'value',
      );
    });

    demandListStore.demandStatusCollection.forEach((demandStatus: DemandStatusModel) => {
      pushIfNotExistsAndNotNull(
        columnsFilters.demandStatus,
        {
          text: demandStatus.label,
          value: demandStatus.iri,
        },
        'value',
      );
    });

    return columnsFilters;
  }
}

const WrappedDemandList = withNavigation(DemandList);

export default WrappedDemandList;
